import { NgModule } from '@angular/core';
import { SelectionGroupsPipe } from './selection-groups.pipe';
import { TransformPipe } from './transform.pipe';

@NgModule({
  declarations: [TransformPipe, SelectionGroupsPipe],
  exports: [TransformPipe, SelectionGroupsPipe]
})
export class PipesModule {}
